import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Container = function Container(_ref) {
  var children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    className = _ref.className,
    _ref$innerSize = _ref.innerSize,
    innerSize = _ref$innerSize === void 0 ? 'default' : _ref$innerSize,
    attributes = _ref.attributes;
  return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
    className: cn('container', "innerSize--".concat(innerSize), "type--".concat(type), className),
    "data-t-id": "PageSection-Container"
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('content')
  }, children));
};